module.exports = __webpack_public_path__ + "media/images/map_icons/Gym-fbb492dff688edacba7c1fe4aedfd61c.svg";